import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import FilterPlate from '..';
import { FILTER_TYPE } from '../constants';

const FilterPlateCChecks = (props) => {
	const {
		options = [],
		initialSelected = [],
		onSubmit,
		onCancel,
		...rest
	} = props;

	const [value, setValue] = useState(() =>
		(initialSelected ?? []).map(String),
	);

	useEffect(() => {
		setValue((initialSelected ?? []).map(String));
	}, [initialSelected]);

	const handleChange = useCallback((event) => {
		const optionValue = String(event.target.value);
		const { checked } = event.target;

		setValue((prev) => {
			if (checked) {
				return prev.includes(optionValue)
					? prev
					: [...prev, optionValue];
			}

			return prev.filter((item) => item !== optionValue);
		});
	}, []);

	const handleSubmit = useCallback(() => {
		onSubmit?.({ value });
	}, [onSubmit, value]);

	const handleCancel = useCallback(() => {
		setValue([]);
		onCancel?.({ value: [] });
	}, [onCancel]);

	return (
		<FilterPlate
			type={FILTER_TYPE.checks}
			payload={{
				options: options.map((option) => ({
					...option,
					checkbox: {
						value: String(option.value),
						...option.checkbox,
					},
				})),
				value,
				onChange: handleChange,
			}}
			onSubmit={handleSubmit}
			onCancel={handleCancel}
			{...rest}
		/>
	);
};

FilterPlateCChecks.propTypes = {
	...FilterPlate.propTypes,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			label: PropTypes.node,
		}),
	),
	initialSelected: PropTypes.arrayOf(
		PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	),
};

export default FilterPlateCChecks;
